module.exports = __webpack_public_path__ + "img/stock8.946be0b1.png";